/**
 * Open state of the Run command dialog. `openRunCommand()` works from anywhere (a checkout
 * row, the palette); <RunCommandHost /> in the shell shows it.
 */
import type { Id } from '@orgus/protocol';
import { create } from 'zustand';

export interface RunCommandPrefill {
  checkoutId?: Id;
  projectId?: Id;
  machineId?: Id;
}

interface RunCommandStore {
  open: boolean;
  prefill: RunCommandPrefill;
}

export const useRunCommand = create<RunCommandStore>()(() => ({ open: false, prefill: {} }));

export function openRunCommand(prefill: RunCommandPrefill = {}): void {
  useRunCommand.setState({ open: true, prefill });
}

export function closeRunCommand(): void {
  useRunCommand.setState({ open: false });
}

/** A command a person typed, checked before it is sent: one line, not empty, not huge. */
export function commandError(command: string): string | null {
  const c = command.trim();
  if (!c) return 'Enter a command to run.';
  if (/[\r\n]/.test(command.trim())) return 'Enter one command on one line. Chain steps with && if you need several.';
  if (c.length > 2000) return 'That command is too long. Put it in a script in the repository and run the script.';
  return null;
}
